import { define } from 'wicked-elements'

define('[data-component~="video-embed"]', {
  init() {
    this.$UI = this.element.querySelector('.video-embed-poster')
    this.$button = this.element.querySelector('button')
    this.$poster = this.element.querySelector('img')
    this.$iframe = this.element.querySelector('iframe')
    this.handleClick = this.handleClick.bind(this)
  },
  connected() {
    this.$button.addEventListener('click', this.handleClick)
  },
  disconnected() {
    this.$button.removeEventListener('click', this.handleClick)
  },
  handleClick() {
    this.$iframe.style.display = 'block'
    this.$UI.style.display = 'none'
  },
})
